import { useAppDispatch, useAppSelector } from 'appState/store'
import { useEffect, useState } from 'react'
// features
import { setAuthSession } from 'features/auth/authSlice'
// types and utils
import { apiPaths } from 'configs/apiConfigs'
import { authApi } from 'features/auth/authApi'
import { httpClaims } from 'utils/http'
import storage, { StorageEnum } from 'utils/storage'

export const useRouterSetup = (): {
  appDown: boolean
  isLoading: boolean
  loggedIn: boolean
} => {
  // global state
  const { user } = useAppSelector((state) => state.auth)

  // props and utils
  const dispatch = useAppDispatch()
  // local state
  const [appDown, setAppDown] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  // check backend service health
  useEffect(() => {
    const checkAuthSession = async () => {
      const authToken = await authApi.getAuthToken()

      if (authToken) {
        const currentUser = storage.get(StorageEnum.currentUser)
        dispatch(setAuthSession({ currentUser }))
      }
    }

    const checkBackendServiceIsDown = async () => {
      setIsLoading(true)

      // Cannot return an error because the api request is catched already, added here to persist the isLoading state
      await checkAuthSession()

      await new Promise((resolve) => setTimeout(resolve, 1000))

      await httpClaims.get(apiPaths.health()).catch(() => {
        setAppDown(true)
        setIsLoading(false)
      })

      setIsLoading(false)
    }
    checkBackendServiceIsDown()
  }, [setAppDown])

  return { appDown, isLoading, loggedIn: !!user }
}
